module.exports = __webpack_public_path__ + "img/Guru_Dharm.372fe59e.jpg";